export default __webpack_public_path__ + "static/media/Totem20.003cca9a.jpg";